var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"panel",staticClass:"resizable-panel",class:{ 'is-resizing': _vm.isResizing, 'dark-theme': _vm.isDark },style:(_vm.panelStyle)},[_c('div',{staticClass:"resize-handle",class:_vm.position,on:{"mousedown":_vm.startResize}},[_c('div',{staticClass:"resize-indicator"})]),_c('div',{staticClass:"panel-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }